<template>
	<div class="user-table-import">
		<div>
			Фильтр по email
			<a-input v-model="filter" allow-clear></a-input>
		</div>

		<a-tabs default-active-key="1">
			<a-tab-pane key="1" tab="Не обработаны">
				<!-- id="user-table-import-not-linked" -->
				<!-- <h2><strong>Не обработаны</strong></h2> -->
				<h3 class="user-table-import__description">
					Эти пользователи еще не связаны с основной таблицей, нужно выбрать OOHDESK_ID для каждого.
				</h3>
				<h3 class="user-table-import__description danger">Выбор OOHDESK_ID нельзя отменить или исправить!</h3>
				<Table class="user-table-import__table" :columns="columns" :items="notLinkedUsers" :loading="isLoading">
					<template #oohdesk_id="{ ...user }">
						<OohdeskId :user="user" :coreUsers="coreUsers" @refresh="$emit('refresh', $event)" />
					</template>

					<template #product="{ products }">
						<a-tag v-for="product in products" :key="product.id" color="blue">{{ product.name }}</a-tag>
					</template>

					<template #profile="{ email }">
						<div class="profile">
							<div class="profile__email">{{ email }}</div>
						</div>
					</template>
				</Table>
			</a-tab-pane>

			<a-tab-pane key="2" tab="Обработаны" force-render>
				<!-- id="user-table-import-linked" -->
				<!-- <h2><strong>Обработаны</strong></h2> -->
				<h3 class="user-table-import__description">Эти пользователи уже связаны с основной таблицей, сохранены тут для отчетности.</h3>
				<Table class="user-table-import__table" :columns="columns" :items="linkedUsers" :loading="isLoading">
					<template #oohdesk_id="{ oohdesk_id }">{{ oohdesk_id }}</template>

					<template #product="{ product }">
						<a-tag color="blue">{{ product.name }}</a-tag>
					</template>

					<template #profile="{ email }">
						<div class="profile">
							<div class="profile__email">{{ email }}</div>
						</div>
					</template>
				</Table>
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
export default {
	name: "UserTableImport",

	components: {
		Table: () => import("@/components/uikit/Table"),
		OohdeskId: () => import("./OohdeskId")
	},

	props: {
		users: { type: Array, required: true },
		coreUsers: { type: Array, required: true },
		isLoading: { type: Boolean, default: false }
	},

	data() {
		return {
			filter: null
		}
	},

	computed: {
		columns() {
			return [
				{ slot: "oohdesk_id", title: "OOHDESK ID" },
				{ slot: "product", title: "Откуда импортировано" },
				{ slot: "profile", title: "Пользователь" },
				{ field: "createdAt", title: "Дата импорта" }
			]
		},

		notLinkedUsers() {
			const users = this.users.filter(user => !user.oohdesk_id)

			if (this.filter) {
				return users.filter(user => user.email.toLowerCase().includes(this.filter.toLowerCase()))
			}

			return users
		},

		linkedUsers() {
			const users = this.users.filter(user => user.oohdesk_id)

			if (this.filter) {
				return users.filter(user => user.email.toLowerCase().includes(this.filter.toLowerCase()))
			}

			return users
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars";

.user-table-import {
	&__description {
		font-size: 14px;
		color: $gray;

		&.danger {
			color: $red;
		}
	}

	&__table {
		margin: 0 0 40px;
	}
}
</style>
